<template>
  <div class="position-relative">
    <img v-if="props.image" :src="props.image" class="p-qr-code__img" width="22" height="23" />
    <div ref="qrContainer" class="p-qr-code" />
  </div>
</template>

<script lang="ts" setup>
import QrCodeStyling from 'qr-code-styling'

const props = defineProps({
  size: {
    type: Number,
    default: 140,
  },
  value: {
    type: String,
    default: 'https://paribu.com/qr',
  },
  image: {
    type: String,
    default: '/icon/paribu.svg',
  },
})

const colorMode = useColorMode()

const qrContainer = ref<HTMLElement | null>(null)
const qrCode = ref<QrCodeStyling | null>(null)

const getStyle = (variable: string): string => {
  if (!import.meta.client) return ''
  return getComputedStyle(document.documentElement).getPropertyValue(variable)
}

const fgColor = computed(() => getStyle('--fg-primary'))
const bgColor = computed(() => getStyle('--bg-white'))

const generateQr = () => {
  if (!qrContainer.value) return

  qrContainer.value.innerHTML = ''

  qrCode.value = new QrCodeStyling({
    width: props.size,
    height: props.size,
    data: props.value,
    dotsOptions: {
      type: 'rounded',
      color: fgColor.value,
    },
    backgroundOptions: {
      color: bgColor.value,
    },
  })

  qrCode.value.append(qrContainer.value)
}

onMounted(() => {
  nextTick(() => {
    generateQr()
  })
})

watch(
  () => props.value,
  () => {
    generateQr()
  },
)

watch(
  () => colorMode.value,
  () => {
    if (qrCode.value) {
      qrCode.value.update({
        dotsOptions: { color: fgColor.value },
        backgroundOptions: { color: bgColor.value },
      })
    }
  },
)
</script>
